import React, { useState } from "react";
import {
  FaAndroid,
  FaAward,
  FaCamera,
  FaDesktop,
  FaFileExport,
  FaFilePdf,
  FaGlobe,
  FaLink,
  FaList,
  FaMobileAlt,
  FaMoneyBillWave,
  FaPrint,
  FaShoppingCart,
  FaStar,
  FaTags,
  FaUser,
  FaUserTie,
} from "react-icons/fa";
import {
  FaTag,
  FaBox,
  FaBarcode,
  FaClipboardList,
  FaCubes,
  FaShieldAlt,
  FaDollarSign,
  FaStickyNote,
  FaWarehouse,
  FaBalanceScale,
  FaEye,
  FaSearch,
} from "react-icons/fa";
import {
  FaCube,
  FaAlignLeft,
  FaRulerCombined,
  FaSortAmountUpAlt,
  FaSortNumericUp,
  FaThList,
  FaBoxes,
  FaToggleOn,
} from "react-icons/fa";
import { MdOutlineLabel } from "react-icons/md";

import product_attributes from "../../../assets/Docs/add_atributes.png";
import { TagComponent } from "../Tabs";

const ProductAttributes = () => {
  const [activeTab1, setActiveTab1] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const content2 = {
    web: "",
    mobile: "",
  };
  const mandatoryAttributes = [
    { icon: <FaClipboardList />, label: "Code" },
    { icon: <FaUser />, label: "Name" },
    { icon: <FaTags />, label: "Category" },
    { icon: <FaTag />, label: "Category 1 (For Data Import Only)" },
    { icon: <FaBox />, label: "Category 2 (For Data Import Only)" },
  ];
  const importableAttributes = [
    { icon: <FaBarcode />, label: "Product ID" },
    { icon: <FaCubes />, label: "SKU" },
    { icon: <FaCube />, label: "Variant" },
    { icon: <FaAlignLeft />, label: "Short Description" },
    { icon: <FaRulerCombined />, label: "Size" },
    { icon: <FaSortAmountUpAlt />, label: "Ordering Unit" },
    { icon: <FaSortNumericUp />, label: "Minimum Order Quantity" },
    { icon: <FaThList />, label: "Order Multiple" },
    { icon: <FaBoxes />, label: "Packing" },
    { icon: <FaTags />, label: "HSN Code" },
    { icon: <FaShieldAlt />, label: "Warranty" },
    { icon: <FaToggleOn />, label: "Stock Status" },
    {
      icon: <FaDollarSign />,
      label: "Price (Price 1 to Price 25 for supporting 25 different prices)",
    },
    { icon: <FaStickyNote />, label: "Notes" },
    { icon: <FaWarehouse />, label: "Warehouses" },
    { icon: <FaBalanceScale />, label: "Tax Tier" },
    { icon: <FaEye />, label: "Visibility Tier" },
    { icon: <FaSearch />, label: "Search Tags (comma separated)" },
  ];
  const attributes = [
    { icon: <FaClipboardList />, label: "Product Specifications" },
    { icon: <FaStar />, label: "Feature List" },
    { icon: <FaLink />, label: "Links (To External URL's)" },
    { icon: <FaCamera />, label: "Photos (upto 10 per product)" },
    { icon: <FaAward />, label: "Badges" },
  ];
  const attribute = [
    { icon: <FaTag />, label: "Custom Name (Visible to your Buyers)" },
    { icon: <FaStickyNote />, label: "Description (For Internal Staff)" },
    {
      icon: <FaMoneyBillWave />,
      label: "Currency & Currency Prefix (For Price Fields)",
    },
    { icon: <FaEye />, label: "Is Public (Yes or No)" },
    { icon: <FaPrint />, label: "Is Printable (Yes or No)" },
    { icon: <FaList />, label: "Display in Order (Yes or No)" },
    { icon: <FaFilePdf />, label: "Include in Order PDF & XLS (Yes or No)" },
    {
      icon: <FaFileExport />,
      label: "Include in Order Export as JSON or XML (Yes or No)",
    },
  ];


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdOutlineLabel className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color"> Products Attributes</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <p className="text-start mb-6 text-gray-600  leading-relaxed">
        Selzor is built to meet the needs of diverse industries. By choosing the
        attributes relevant to your products, you can create a product catalogue
        tailored to your requirements.
      </p>

      <div className="p-4 text-gray-700 text-sm">
        {/* Mandatory Product Attributes */}
        <section className="mb-6">
          <h2 className="text-base text-start font-semibold mb-3">
            Mandatory Product Attributes
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            {mandatoryAttributes.map((item, index) => (
              <li key={index} className="flex items-center gap-3 p-3">
                <span className="text-blue-600">{item.icon}</span>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Product Attributes (Importable) */}
        <section>
          <h2 className="text-base text-start font-semibold mb-3">
            Product Attributes (Importable)
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            {importableAttributes.map((item, index) => (
              <li key={index} className="flex items-center gap-3 p-3">
                <span className="text-blue-600">{item.icon}</span>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Product Attributes (Other) */}
        <section>
          <h2 className="text-base text-start font-semibold mb-3">
            Product Attributes (Other)
          </h2>
          <ul className="border border-gray-200 rounded divide-y divide-gray-200">
            {attributes.map((item, index) => (
              <li key={index} className="flex items-center gap-3 p-3">
                <span className="text-blue-600">{item.icon}</span>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <div className="my-5">
        {renderTabs(activeTab1, setActiveTab1)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={product_attributes}
            alt={`${activeTab1} view`}
            className="rounded-lg  max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      {/* Product Attributes Settings */}
      <section>
        <h2 className="  text-start font-semibold mb-3">
          Product Attributes Settings
        </h2>
        <p className="text-start my-4">
          You have full flexibility to rename and rearrange these attributes,
          which also come with additional configuration options.
        </p>
        <ul className="border border-gray-200 rounded divide-y divide-gray-200">
          {attribute.map((item, index) => (
            <li key={index} className="flex items-center gap-3 p-3">
              <span className="text-blue-600">{item.icon}</span>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      </section>

      <div className="my-5">
        {renderTabs(activeTab1, setActiveTab1)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={content2[activeTab1]}
            alt={`${activeTab1} view`}
            className="rounded-lg  max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductAttributes;
